/**
 * FP3-043 Phase C — Demo / test / archived classification pill.
 *
 * Surfaces `data_classification` on any row (org, school, user,
 * invite, access request) so Super Admin can tell at a glance which
 * rows are part of the curated demo set vs. test scratch data.
 *
 * Renders nothing when:
 *   - the row has no classification, or
 *   - the row is classified `production` (no badge needed).
 *
 * Keep this dumb — no API calls, no toggling. The Super Admin
 * controls visibility via the persistent show-hidden toggle on
 * Platform Dashboard.
 */
const TONES = {
  curated_demo: { bg: "#E8F0EB", fg: "#1E3F33", label: "Demo" },
  demo: { bg: "#E8F0EB", fg: "#1E3F33", label: "Demo" },
  test: { bg: "#FBF3E4", fg: "#9C6B2E", label: "Test" },
  archived_test: { bg: "#F8EFEA", fg: "#7A3A2C", label: "Archived test" },
  orphan_needs_review: { bg: "#F4E6CD", fg: "#9C6B2E", label: "Orphan" },
  unclassified: { bg: "#F1F2F4", fg: "#6B7280", label: "Unclassified" },
};

export default function ClassificationBadge({ row, testid }) {
  if (!row) return null;
  const cls = (row.data_classification || "").toLowerCase();
  if (!cls || cls === "production" || cls === "system") return null;
  const tone = TONES[cls] || TONES.unclassified;
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center text-[9.5px] font-semibold uppercase tracking-[0.08em] rounded-full px-1.5 py-0.5 leading-none whitespace-nowrap"
      style={{ backgroundColor: tone.bg, color: tone.fg }}
      title={`Classification: ${cls.replace("_", " ")}`}
    >
      {tone.label}
    </span>
  );
}
